import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

// images
import img1 from "../../../assets/images/images-1.jpg";
import img2 from "../../../assets/images/images-2.jpg";
import img3 from "../../../assets/images/images-3.jpg";
import img4 from "../../../assets/images/images-4.jpg";
import img6 from "../../../assets/images/images-6.jpg";
import img7 from "../../../assets/images/images-7.jpg";
import { SlideshowLightbox } from "lightbox.js-react";
import 'lightbox.js-react/dist/index.css'

const LightboxPage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Lightbox" pageType="Components" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Example
            </h2>
            <SlideshowLightbox className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
                <img src={img1} alt="" className="rounded-xl" />
                <img src={img2} alt="" className="rounded-xl" />
                <img src={img3} alt="" className="rounded-xl" />
                <img src={img4} alt="" className="rounded-xl" />
                <img src={img6} alt="" className="rounded-xl" />
                <img src={img7} alt="" className="rounded-xl" />
            </SlideshowLightbox>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LightboxPage;
